// ICreateObraPlanoTreinamentoUseCase

import { ICreateObraPlanoTreinamentosUseCase } from "../../../presentation/useCases/create/create_obra_plano_treinamento_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

export class CreateObraPlanoTreinamentoUseCase implements ICreateObraPlanoTreinamentosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObraPlanoTreinamento(
    ID_OBRA: number,
    Cargo: string,
    TIPO_TREINAMENTO: string,
  ): Promise<void> {
    await this.repository.createObraPlanoTreinamento(
      ID_OBRA,
      Cargo,
      TIPO_TREINAMENTO,
    );
  }
}

